<template>
  <NiceView :title="CommonService.routes.SANDBOX.title" :icon="CommonService.routes.SANDBOX.icon">
    <dialog class="nice-modal" :open="modalIsOpen">Test</dialog>

    <!-- Permission -->
    <NiceWrapper title="Permissions">
      <div class="badges">
        <div class="badge mb-1" :class="value ? 'badge-success' : 'badge-danger'" v-for="(value, key) of permissions" :key="key">
          <NiceIcon :icon="value ? 'icon-check' : 'icon-x'" style="height: 15px; width: 15px"></NiceIcon>
          <span>{{ key }}</span>
        </div>
      </div>
      <!-- <pre>{{ permissions }}</pre> -->
    </NiceWrapper>

    <!-- Modules -->
    <NiceWrapper title="Modules">
      <div class="badges">
        <div class="badge mb-1" :class="value ? 'badge-success' : 'badge-danger'" v-for="(value, key) of modules" :key="key">
          <NiceIcon :icon="value ? 'icon-check' : 'icon-x'" style="height: 15px; width: 15px"></NiceIcon>
          <span>{{ key }}</span>
        </div>
      </div>
      <!-- <pre>{{ modules }}</pre> -->
    </NiceWrapper>

    <NiceWrapper title="Badge" collapsable>
      <div class="badges mb-2">
        <div class="badge">Default</div>
        <div class="badge badge-primary">Primary</div>
        <div class="badge badge-secondary">Secondary</div>
        <div class="badge badge-danger">Danger</div>
        <div class="badge badge-success">Success</div>
        <div class="badge badge-warning">Warning</div>
        <div class="badge badge-info">Info</div>
        <div class="badge badge-color-1">Badge 1</div>
        <div class="badge badge-color-2">Badge 2</div>
        <div class="badge badge-color-3">Badge 3</div>
        <div class="badge badge-color-4">Badge 4</div>
      </div>
      <div class="badges mb-2">
        <div class="badge badge-rounded">Default</div>
        <div class="badge badge-rounded badge-primary">Primary</div>
        <div class="badge badge-rounded badge-secondary">Secondary</div>
        <div class="badge badge-rounded badge-danger">Danger</div>
        <div class="badge badge-rounded badge-success">Success</div>
        <div class="badge badge-rounded badge-warning">Warning</div>
        <div class="badge badge-rounded badge-info">Info</div>
        <div class="badge badge-rounded badge-color-1">Badge 1</div>
        <div class="badge badge-rounded badge-color-2">Badge 2</div>
        <div class="badge badge-rounded badge-color-3">Badge 3</div>
        <div class="badge badge-rounded badge-color-4">Badge 4</div>
      </div>
      <div class="badges">
        <div class="badge badge-sm">Default</div>
        <div class="badge badge-sm badge-primary">Primary</div>
        <div class="badge badge-sm badge-secondary">Secondary</div>
        <div class="badge badge-sm badge-danger">Danger</div>
        <div class="badge badge-sm badge-success">Success</div>
        <div class="badge badge-sm badge-warning">Warning</div>
        <div class="badge badge-sm badge-info">Info</div>
        <div class="badge badge-sm badge-color-1">Badge 1</div>
        <div class="badge badge-sm badge-color-2">Badge 2</div>
        <div class="badge badge-sm badge-color-3">Badge 3</div>
        <div class="badge badge-sm badge-color-4">Badge 4</div>
      </div>
    </NiceWrapper>

    <!-- Table -->
    <NiceWrapper title="Table" collapsable no-body-padding>
      <NiceTable :data="data" :columns="columns" selectMultiple showFooter @selected="model.selectedItems" />
    </NiceWrapper>

    <!-- Form -->
    <NiceWrapper title="Form" subtitle="This is a sandbox for nice elements" collapsable>
      <!-- Panel -->
      <h5>Panel</h5>
      <NiceButton type="primary" text="Open panel" @click="openPanel" />
      <NicePanel name="sandbox">This is a panel</NicePanel>

      <!-- Modal -->
      <h5 class="mt-4">Modal</h5>
      <NiceButton type="primary" text="Open modal" @click="openModal" />
      <NiceModal name="sandbox-modal">This is a modal</NiceModal>

      <!-- Popup -->
      <h5 class="mt-4">Popup</h5>
      <NicePopup>
        <template #trigger>
          <NiceButton type="primary" icon="icon-more-vertical" />
        </template>
        <template #content>This is the content</template>
      </NicePopup>

      <!-- Checkbox -->
      <h5 class="mt-4">Checkbox</h5>
      <NiceCheckbox v-model="model.checkbox" title="Checkbox label" />

      <!-- Switch -->
      <h5 class="mt-4">Switch</h5>
      <NiceSwitch v-model="model.switch" class="mr-2" size="small" title="Switch small" />
      <NiceSwitch v-model="model.switch" class="mr-2" title="Switch label" />
      <NiceSwitch v-model="model.switch" class="mr-2" size="large" title="Switch large" />

      <!-- Input -->
      <h5 class="mt-4">Input</h5>
      <NiceInput v-model="model.input" title="Input" />

      <NiceInput v-model="model.input" title="Input" caption="Caption text" message="Bottom message" placeholder="Placeholder">
        <template #suffix>
          <NiceButton text="Button" />
        </template>
        <template #append>
          <NiceButton text="Button" />
        </template>
      </NiceInput>

      <!-- Dropdown -->
      <h5 class="mt-4">Dropdown</h5>
      <NiceDropdownSimple
        title="Dropdown simple"
        :values="countries"
        v-model="model.dropdownSimple"
        keyName="iso"
        valueName="name"
        @change="onChange"
      />

      <NiceDropdownSimple title="Dropdown simple" :values="countries" v-model="model.dropdownSimpleKeyOnly" keyName="iso" valueName="name" keyOnly />

      <NiceDropdown title="Dropdown nullable" :searchFunction="findCountries" v-model="model.dropdown" keyName="iso" valueName="name" nullable />

      <NiceDropdown
        title="Countries"
        :searchFunction="findCountries"
        v-model="model.dropdown2"
        keyName="iso"
        valueName="name"
        :addFunction="addFunction"
      >
        <template #selected-option="{ item }">
          <span class="fi mr-2" :class="'fi-' + item.iso.toLowerCase()"></span>
          <span>{{ item.name }}</span>
        </template>
        <template #option="{ item }">
          <span class="fi mr-2" :class="'fi-' + item.iso.toLowerCase()"></span>
          <span>{{ item.name }}</span>
        </template>
      </NiceDropdown>

      <!-- Date -->
      <h5 class="mt-4">Date</h5>
      <NiceDate title="Date" v-model="model.date" />

      <!-- Avatar -->
      <h5 class="mt-4">Avatar</h5>
      <div class="mb-2">
        <NiceAvatar />
        <NiceAvatar text="KK" />
        <NiceAvatar text="KK" shape="square" />
        <NiceAvatar text="KK" shape="rounded" />
      </div>

      <div class="mb-2">
        <NiceAvatar text="KK" gradient size="large" />
        <NiceAvatar text="KK" gradient size="medium" />
        <NiceAvatar text="KK" gradient size="small" />
        <NiceAvatar text="KK" gradient size="mini" />
        <NiceAvatar text="KK" gradient />
        <NiceAvatar text="KK" gradient shape="square" />
        <NiceAvatar text="KK" gradient shape="rounded" />
      </div>

      <div class="mb-2">
        <NiceAvatar text="KK" size="large" />
        <NiceAvatar text="KK" size="default" />
        <NiceAvatar text="KK" size="medium" />
        <NiceAvatar text="KK" size="small" />
        <NiceAvatar text="KK" size="mini" />
      </div>

      <div class="mb-2">
        <NiceAvatar :image="image" shape="square" />
        <NiceAvatar :image="image" shape="rounded" />
        <NiceAvatar :image="image" text="KK" />
        <NiceAvatar :image="image" size="large" />
        <NiceAvatar :image="image" size="default" />
        <NiceAvatar :image="image" size="medium" />
        <NiceAvatar :image="image" size="small" />
        <NiceAvatar :image="image" size="mini" />
      </div>

      <div class="mb-2">
        <NiceAvatar :image="image" text="KK" status="primary" />
        <NiceAvatar :image="image" text="KK" status="success" />
        <NiceAvatar :image="image" text="KK" status="danger" />
        <NiceAvatar :image="image" text="KK" status="warning" />
        <NiceAvatar :image="image" text="KK" status="default" />
      </div>

      <div class="mb-2">
        <NiceAvatar gavatar="klemen.kast@gmail.com" />
        <NiceAvatar gavatar="klemen@olaii.com" />
        <NiceAvatar gavatar="boris@olaii.com" />
        <NiceAvatar gavatar="info@olaii.com" />
        <NiceAvatar gavatar="martin@olaii.com" />
      </div>

      <div class="mb-2">
        <NiceAvatar text="KK" type="primary" />
        <NiceAvatar text="KK" type="success" />
        <NiceAvatar text="KK" type="danger" />
        <NiceAvatar text="KK" type="warning" />
        <NiceAvatar text="KK" type="info" />
        <NiceAvatar text="KK" type="dark" />
      </div>

      <div>
        <NiceAvatar text="KK" plain type="primary" />
        <NiceAvatar text="KK" plain type="success" />
        <NiceAvatar text="KK" plain type="danger" />
        <NiceAvatar text="KK" plain type="warning" />
        <NiceAvatar text="KK" plain type="info" />
        <NiceAvatar text="KK" plain type="dark" />
      </div>

      <template #footer>
        <pre>{{ model }}</pre>
      </template>
    </NiceWrapper>

    <!-- Buttons -->
    <NiceWrapper title="Buttons" collapsable>
      <h2>Default Buttons</h2>

      <h3>Default</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" :text="t" />

      <h3>Round</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" rounded :text="t" />

      <hr />

      <h2>Plain Buttons</h2>

      <h3>Default</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" plain :text="t" />

      <h3>Round</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" rounded plain :text="t" />

      <hr />

      <h2>Outline Buttons</h2>

      <h3>Default</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" outline :text="t" />

      <h3>Round</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" outline rounded :text="t" />

      <hr />

      <h2>Naked Buttons</h2>

      <h3>Default</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" naked :text="t" />

      <br />
      <br />

      <NiceButton v-for="t in types" :key="t" :type="t" naked icon="icon-circle" :text="t" />

      <h3>Round</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" naked rounded :text="t" />

      <br />
      <br />

      <NiceButton v-for="t in types" :key="t" :type="t" naked rounded icon="icon-circle" :text="t" />

      <hr />

      <h2>Buttons With Text & Icon</h2>

      <h3>Default</h3>
      <NiceButton icon="icon-circle" type="primary">Primary</NiceButton>
      <NiceButton append-icon="icon-circle" type="default">Default</NiceButton>
      <NiceButton plain icon="icon-circle" type="primary">Primary</NiceButton>
      <NiceButton plain append-icon="icon-circle" type="default"> Default </NiceButton>

      <h3>Rounded</h3>
      <NiceButton icon="icon-circle" rounded type="primary" text="Primary" />
      <NiceButton append-icon="icon-circle" rounded type="default" text="Default" />
      <NiceButton plain rounded icon="icon-circle" type="primary" text="Primary" />
      <NiceButton plain rounded append-icon="icon-circle" type="default" text="Default" />

      <h3>Icon</h3>
      <NiceButton icon="icon-circle" type="primary"></NiceButton>
      <NiceButton rounded icon="icon-circle" type="default"></NiceButton>
      <NiceButton plain icon="icon-circle" type="success"></NiceButton>
      <NiceButton plain rounded icon="icon-circle" type="danger"></NiceButton>

      <hr />

      <h3>Button Sizes</h3>
      <NiceButton size="large" type="primary">Large</NiceButton>
      <NiceButton size="large" type="primary" icon="icon-circle"></NiceButton>

      <NiceButton type="primary">Normal</NiceButton>
      <NiceButton type="primary" icon="icon-circle"></NiceButton>

      <NiceButton size="small" type="primary">Small</NiceButton>
      <NiceButton size="small" type="primary" icon="icon-circle"></NiceButton>

      <hr />

      <h3>Button Loading</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" loading text="Loading" />

      <hr />

      <h3>Button Disabled</h3>
      <NiceButton v-for="t in types" :key="t" :type="t" disabled text="Disabled" />
    </NiceWrapper>

    <!-- Notification and Toast -->
    <NiceWrapper title="Notification and Toast" collapsable>
      <h3>Toast</h3>
      <NiceButton plain type="primary" @click="toast('primary')" text="Primary" />

      <NiceButton plain type="default" @click="toast('default')" text="Default" />
      <NiceButton plain type="success" @click="toast('success')" text="Success" />
      <NiceButton plain type="danger" @click="toast('danger')" text="Danger" />
      <NiceButton plain type="warning" @click="toast('warning')" text="Warning" />
      <NiceButton plain type="info" @click="toast('info')" text="Info" />
      <NiceButton plain type="dark" @click="toast('dark')" text="Dark" />

      <h3>Notification</h3>
      <NiceButton type="primary" @click="notification('primary')" text="Primary" />

      <NiceButton type="default" @click="notification()" text="Default" />
      <NiceButton type="success" @click="notification('success')" text="Success" />
      <NiceButton type="danger" @click="notification('danger')" text="Danger" />
      <NiceButton type="warning" @click="notification('warning')" text="Warning" />
      <NiceButton type="info" @click="notification('info')" text="Info" />
      <NiceButton type="dark" @click="notification('dark')" text="Dark" />
    </NiceWrapper>

    <!-- Icons -->
    <NiceWrapper :title="'Icons ' + icons.length" collapsable>
      <div class="icons">
        <NiceButton class="icon-wrapper" type="dark" v-for="icon in icons" :key="icon" :naked="true" @click="copyIcon(icon)">
          <NiceIcon :icon="icon" />
          <div>{{ icon }}</div>
        </NiceButton>
      </div>
    </NiceWrapper>

    <!-- Footer -->
    <template #footer>
      <NiceButton plain type="default">Reset</NiceButton>
      <NiceButton plain type="default" @click="crash">Crash</NiceButton>
      <div class="grow"></div>
      <NiceButton plain type="danger">Cancel</NiceButton>
      <NiceButton>Submit</NiceButton>
    </template>
  </NiceView>
</template>

<script setup>
import CommonService from "@/services/common.service";
import { ref, inject, onMounted } from "vue";
import { formatDateWithTime } from "@/plugins/date";
import { formatCurrency } from "@/plugins/currency";
const $nice = inject("nice");

import { useGeneralStore } from "@/store/general.store";
const generalStore = useGeneralStore();
const permissions = ref(generalStore.permissions);
const modules = ref(generalStore.modules);

const image = require("@/assets/user.png");
const modalIsOpen = ref(false);
const model = ref({
  checkbox: true,
  switch: true,
  input: "",
  dropdown: null,
  dropdown2: null,
  dropdownSimple: null,
  dropdownSimpleKeyOnly: "SI",
});

const types = ["primary", "default", "success", "danger", "warning", "info", "dark", "white"];

const statuses = {
  PAID: "badge-success",
  PENDING: "badge-warning",
  FAILED: "badge-danger",
};

const columns = [
  {
    name: "Number",
    key: "number",
  },
  {
    name: "Device",
    key: "device",
  },
  {
    name: "Amount",
    key: "amount",
    class: "text-right",
    formatter: (v) => formatCurrency(v),
  },
  {
    name: "Status",
    key: "status",
    class: "text-center",
    fieldClass: (v) => "badge " + statuses[v],
  },
  {
    name: "Date issued",
    key: "issued",
    class: "text-right",
    formatter: (v) => formatDateWithTime(v),
  },
];
const data = [
  {
    id: 1,
    number: "BL-1-1",
    device: "Device 1",
    amount: "1.5",
    status: "PAID",
    issued: "2022-08-29T14:27:41.774Z",
  },
  {
    id: 2,
    number: "BL-1-2",
    device: "Device 1",
    amount: "2.55",
    status: "PENDING",
    issued: "2022-08-29T14:27:41.774Z",
  },
  {
    id: 3,
    number: "BL-1-3",
    device: "Device 1",
    amount: "12.5",
    status: "PAID",
    issued: "2022-08-29T14:27:41.774Z",
  },
  {
    id: 4,
    number: "BL-1-4",
    device: "Device 2",
    amount: "50",
    status: "FAILED",
    issued: "2022-08-29T14:27:41.774Z",
  },
  {
    id: 5,
    number: "BL-1-5",
    device: "Device 2",
    amount: "12.5",
    status: "PAID",
    issued: "2022-08-29T14:27:41.774Z",
  },
  {
    id: 6,
    number: "BL-1-5",
    device: "Device 2",
    amount: "12001.5",
    status: "PAID",
    issued: "2022-08-29T14:27:41.774Z",
  },
];

const countries = [];
const icons = ref([]);

// const holder = {
//   id: 124,
//   first_name: "anze",
//   last_name: "rupnik",
//   address: "",
//   address_line_two: "",
//   city: "",
//   zip_code: "",
//   country: "",
//   birthday: null,
//   phone_number: "",
//   email: "",
//   created_at: "2023-02-03T09:19:23.046995Z",
//   updated_at: "2023-02-03T09:19:23.047074Z",
// };

function copyIcon(icon) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(icon);
    $nice.toast("Copied text: " + icon);
  } else {
    $nice.toast("Error", "danger");
  }
}

function openModal() {
  $nice.modal("sandbox-modal", true);
}

function openPanel() {
  $nice.panel("sandbox", true);
}

function toast(type) {
  $nice.toast(type + " type", type);
}

function crash() {
  // eslint-disable-next-line no-console
  console.log("CRASH");
  // eslint-disable-next-line no-undef
  myUndefinedFunction();
}

function notification(type) {
  $nice.notification("Fruitcake chodolate bar tooties roll gummies gummies jelly beans cake.", type, "Notification " + type, "icon-life-buoy");
}

function findCountries(search) {
  return countries.filter((c) => c.name.toLocaleLowerCase().includes((search || "").toLocaleLowerCase()));
}

function onChange(a) {
  // eslint-disable-next-line no-console
  console.log("[SANDBOX] onChange", a);
}

function addFunction() {
  // eslint-disable-next-line no-console
  console.log("[SANDBOX] add");
}

onMounted(() => {
  icons.value = Array.from(document.getElementsByTagName("symbol")).map((element) => {
    return element.id;
  });
});
</script>

<style lang="scss" scoped>
.icons {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));

  .icon-wrapper {
    text-align: center;
    font-size: 0.8em;
    flex-direction: column;
    height: auto;

    span {
      margin: 0;
    }

    .nice-icon {
      height: 30px;
      width: 30px;
    }
  }
}

dialog {
  z-index: 100;
  border-radius: var(--nice-border-radius);
  border: 1px solid var(--nice-border-color);
  background: var(--nice-card-bg);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
  min-width: 500px;
  max-width: 90%;

  &::backdrop {
    background-color: hsl(250, 100%, 50%, 0.25);
  }
}
</style>
